import React from 'react';
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';

/**
 * ConfigurationStatusBadge
 * Displays provider's service type configuration completeness
 * 
 * @param {Array} providerServiceRates - Array of configured service rates for the provider
 * @param {Array} activeServiceTypes - Array of all active service types in the system
 * @param {Object} sx - Additional Material-UI styling
 */
function ConfigurationStatusBadge({ providerServiceRates = [], activeServiceTypes = [], sx = {} }) {
  const configuredCount = providerServiceRates.length;
  const totalCount = activeServiceTypes.length;
  
  // Calculate completeness percentage
  const completeness = totalCount > 0 ? (configuredCount / totalCount) * 100 : 0;
  
  // Determine color and icon based on completeness
  let color = 'error';
  let icon = <ErrorIcon />;
  
  if (completeness === 100) {
    color = 'success';
    icon = <CheckCircleIcon />;
  } else if (completeness >= 50) {
    color = 'warning';
    icon = <WarningIcon />;
  }
  
  // Handle edge case of no active service types
  if (totalCount === 0) {
    return (
      <Chip 
        label="No Service Types" 
        size="small" 
        color="default"
        sx={sx}
      />
    );
  }
  
  return (
    <Chip 
      icon={icon}
      label={`${configuredCount}/${totalCount} Configured`}
      size="small"
      color={color}
      sx={sx}
    />
  );
}

export default ConfigurationStatusBadge;

